import * as React from 'react';
import cx from 'classnames';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  onClick: () => void;
  text?: string;
  children?: React.ReactNode;
  className?: string;
}

export default ({ onClick, text, children, className = '', ...rest }: Props) => (
  <span
    role="button"
    className={cx('cc__link_button', className)}
    onClick={onClick}
    {...rest}
  >
    {text || children}
  </span>
);
